<script lang="ts">
	import CmsImage from '$lib/components/CmsImage.svelte';
	import LinkList from './_LinkList.svelte';
	import PaymentProviderList from './_PaymentProviderList.svelte';
	import Signet from './_Signet.svelte';
	import type { CmsFooterRecord } from '$lib/data/types';
	import { production } from '$lib/const';
	import { version } from '$app/environment';

	export let footer: CmsFooterRecord;
</script>

<div class="flex">
	<footer class="footer">
		{#if footer.pre_footer_image}
			<CmsImage image={footer.pre_footer_image} href={footer.pre_footer_image_url} />
		{/if}

		<div class="container">
			<LinkList columns={footer.columns} />
			<PaymentProviderList />
			<Signet />

			{#if !production}
				<small>Version: <code>{version}</code></small>
			{/if}
		</div>
	</footer>
</div>

<style>
	.flex {
		display: flex;
		flex-flow: column nowrap;
	}

	.container {
		display: flex;
		flex-direction: column;
		gap: 4rem;
		padding: 2rem;
	}

	footer {
		background-color: #4e4e4e;
		color: #ffffff;
		padding-bottom: 2em;
	}

	small {
		text-align: center;
	}

	@media (min-width: 768px) {
		footer {
			padding-left: 4.6875rem;
			padding-right: 4.6875rem;
		}
	}

	@media (min-width: 1200px) {
		footer {
			padding-left: 5rem;
			padding-right: 0;
		}
	}
</style>
